<template>
  <VueSelect
    :id="name"
    v-model="selected"
    :options="options"
    :filterable="false"
    :placeholder="modelValue"
    name="address"
    label="tekst"
    @search="getAddressOptions"
  />
</template>

<script>
import axios from 'axios';
import Utility from '@/common/UtilityFunctions.js';
import FormComponentMixin from './_FormComponentMixin';

export default {
  name: 'Address',
  mixins: [FormComponentMixin],
  data() {
    return {
      options: [],
      selected: null
    };
  },
  mounted() {
    document.getElementById(this.name).querySelector('input').focus();
  },
  methods: {
    getAddressOptions(search, loading) {
      const vm = this;
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      loading(true);
      axios
        .get(Utility.constants().externalAPI.dawa_adresser + search, config)
        .then((resp) => {
          vm.options = search.trim().length > 0 ? resp.data : [this.selected];
          loading(false);
          this.$emit('update:modelValue', this.selected.tekst);
          this.$emit('change', true);
        })
        .catch(() => {
          loading(false);
        });
    }
  }
};
</script>
